var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3c-1.104 0-2 .895-2 2v10c0 1.105.896 2 2 2h10c1.105 0 2-.895 2-2V5c0-1.105-.895-2-2-2H5zm.8 5.2c0-.552.448-1 1-1h3.6c.552 0 1 .448 1 1V9c0 .552-.448 1-1 1H6.8c-.552 0-1-.448-1-1v-.8zm0 4.2c0-.552.448-1 1-1h6.4c.553 0 1 .448 1 1v.8c0 .552-.447 1-1 1H6.8c-.552 0-1-.448-1-1v-.8z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnits);
export default __webpack_public_path__ + "static/media/units.5d94b0917427f387447146cf087662c6.svg";
export { ForwardRef as ReactComponent };